/* tslint:disable:max-line-length */

import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { APIConfigService } from '../apiconfig.service';

import * as __utils from '../yasag-utils';

import * as __model from '../model';

export interface ListParams {
  /** A search term. */
  search?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Codi residu */
  codi_residu?: string;
  /** Codi fraccio */
  codi_fraccio?: string;
  /** Sinonim */
  sinonim?: boolean;
  /** Lang */
  lang?: LangListParamsEnum;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
}

export type LangListParamsEnum =
  'ca' |
  'es' |
  'en';

export interface CreateParams {
  data: __model.Sinonim;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
}

export interface ReadParams {
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
  /** A unique integer value identifying this sinonim. */
  id: number;
}

export interface UpdateParams {
  data: __model.Sinonim;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
  /** A unique integer value identifying this sinonim. */
  id: number;
}

export interface PartialUpdateParams {
  data: __model.Sinonim;
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
  /** A unique integer value identifying this sinonim. */
  id: number;
}

export interface DeleteParams {
  /** A unique integer value identifying this sinonim. */
  id: number;
}

@Injectable()
export class SinonimService {
  constructor(
    private http: HttpClient,
    private apiConfigService: APIConfigService) {}


  /** List all synonyms with optional filtering by codi_residu or codi_fraccio. */
  list(params: ListParams, multipart = false): Observable<__model.SinonimList> {
    const queryParamBase = {
      search: params.search,
      limit: params.limit,
      offset: params.offset,
      codi_residu: params.codi_residu,
      codi_fraccio: params.codi_fraccio,
      sinonim: params.sinonim,
      lang: params.lang,
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    return this.http.get<__model.SinonimList>(this.apiConfigService.options.apiUrl + `/sinonim/`, {params: queryParams});
  }

  /** Creates a new synonym */
  create(params: CreateParams, multipart = false): Observable<__model.Sinonim> {
    const bodyParams = params.data;
    const bodyParamsWithoutUndefined = __utils.getBodyParamsWithoutUndefined(multipart, bodyParams);

    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    return this.http.post<__model.Sinonim>(this.apiConfigService.options.apiUrl + `/sinonim/`, bodyParamsWithoutUndefined, {params: queryParams});
  }

  /** Gets a synonym by ID */
  read(params: ReadParams, multipart = false): Observable<__model.Sinonim> {
    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    const pathParams = {
      id: params.id,
    };
    return this.http.get<__model.Sinonim>(this.apiConfigService.options.apiUrl + `/sinonim/${pathParams.id}/`, {params: queryParams});
  }

  /** Updates a synonym */
  update(params: UpdateParams, multipart = false): Observable<__model.Sinonim> {
    const bodyParams = params.data;
    const bodyParamsWithoutUndefined = __utils.getBodyParamsWithoutUndefined(multipart, bodyParams);

    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    const pathParams = {
      id: params.id,
    };
    return this.http.put<__model.Sinonim>(this.apiConfigService.options.apiUrl + `/sinonim/${pathParams.id}/`, bodyParamsWithoutUndefined, {params: queryParams});
  }

  /** Partially updates a synonym */
  partialUpdate(params: PartialUpdateParams, multipart = false): Observable<__model.Sinonim> {
    const bodyParams = params.data;
    const bodyParamsWithoutUndefined = __utils.getBodyParamsWithoutUndefined(multipart, bodyParams);

    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    const pathParams = {
      id: params.id,
    };
    return this.http.patch<__model.Sinonim>(this.apiConfigService.options.apiUrl + `/sinonim/${pathParams.id}/`, bodyParamsWithoutUndefined, {params: queryParams});
  }

  /** Deletes a synonym */
  delete(params: DeleteParams, multipart = false): Observable<string> {
    const pathParams = {
      id: params.id,
    };
    return this.http.delete(this.apiConfigService.options.apiUrl + `/sinonim/${pathParams.id}/`, {responseType: 'text'});
  }
}
